export const images = import.meta.glob('./*.{png,jpg}', { eager: true, as: 'url' });
